import useIndicator, { Indicator } from '@shared/hooks/src/useIndicator'

export default function useTotalUnreadMessageCount() {
  const { data: totalUnreadMessageCount } = useIndicator(Indicator.TotalUnreadMessageCount, undefined, {
    select: (_) => _.count,
  })

  return totalUnreadMessageCount
}
